import React from 'react';
import apiFleetio from '../../../../libs/apiFleetio';
import swal from 'sweetalert2';
import { apiDriverApp } from '../../../../libs/apiDriverApp';
import moment from 'moment';


export const MapToFleetIOButton = (props) => {
    const {
        username,
        fleetio_id,
        last_sync,
        onClick,
    } = props;

    const [loading, setLoading] = React.useState(false);

    const mapToFleetio = async () => {
        setLoading(true);
        try {
            if (!username) {
                swal('Error', 'Invalid Username', 'error');
                return;
            }
            const { data } = await apiFleetio.get(`api/contacts`, {
                params: {
                    "per_page": 100,
                    "filter[employee_number][eq]": username,
                }
            });

            const fleetio_last_sync_date = moment();
            const dataToUpdate = {
                fleetio_last_sync_date,
            }
            
            if (!data.records[0]) {
                swal.fire({
                    type: "warning",
                    title: "NOT FOUND!",
                    text: "Driver not found in Fleetio. Make sure the Fleetio username ends with this driver's Driver ID (last 4 characters)."
                });
            } else {
                dataToUpdate.fleetio_id = data.records[0].id;
            }
            
            await apiDriverApp.post('api/hr/employees/update_or_create/', {
                username,
                ...dataToUpdate
            });

            if (onClick)
                onClick(dataToUpdate);

        } catch (error) {
            console.error(error);
            const errorMsg = error.response && error.response.data
                ? error.response.data.errors
                    ? 'The format or parameters of the request was invalid.'
                    : error.response.data.detail || error.response.data.error
                : error;

            const title = error.response && error.response.data
                ? error.response.data.title
                : 'ERROR!';

            swal.fire({
                type: "error",
                title: title,
                text: errorMsg,
            })
        } finally {
            setLoading(false);
        }
    }

    if (fleetio_id)
        return (
            <input
                type="text"
                className="form-control"
                value={fleetio_id}
                disabled
            />
        )

    return (
        <div className="d-flex flex-column">
            <div>
                <button
                    type="button"
                    className="btn btn-sm btn-light border"
                    onClick={mapToFleetio}
                    disabled={!username || loading}
                    style={{
                        'cursor': loading
                            ? 'not-allowed'
                            : 'pointer'
                    }}
                >
                    {loading ? (
                        <div className="d-flex align-items-center">
                            <div
                                className="spinner-border text-primary spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                            />
                            <span className="ml-1">
                                Loading...
                            </span>
                        </div>
                    ) : (
                        'Map to Fleetio'
                    )}
                </button>
            </div>
            {last_sync && (
                <small>
                    <span>
                        Last Tried:
                    </span>
                    <span className="ml-1">
                        {moment(last_sync).format('MM-DD-YY HH:mm')}
                    </span>
                </small>
            )}
        </div>
    )
}